import { format } from 'date-fns';

export const toDatetimeInputValue = (date: Date) => {
  return format(date, 'yyyy-MM-dd') + 'T' + format(date, 'hh:mm');
};

export const toDateInputValue = (date: Date) => {
  return format(date, 'yyyy-MM-dd');
};
